module.exports = __webpack_public_path__ + "img/no-data-by-anatoly.504ee6ca.png";